// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2Phqz","title":"BackImages_title__3eVkd","images":"BackImages_images__Ra9e5"};